import angular from 'angular'
import orgSettingsJsonComponent from './orgSettingsJson.component'

export default angular
  .module('ellipsis.orgSettingsJson', [])
  .component('orgSettingsJson', orgSettingsJsonComponent)
